import { GlobalController } from 'src/shared/global/GlobalController'
import IntegrationLatis from './IntegrationLatis.vue'
const ifAuthenticated = (to, from, next) => {
  GlobalController.getAsyncInstance().then(data => {
    if (data && data.authResp && data.authResp.token) {
      next()
    } else {
      next('/')
    }
  })
}
export const routes = [
  {
    path: ':link',
    name: 'integration-latis',
    component: IntegrationLatis,
    beforeEnter: ifAuthenticated,
    props: true
  }
]
